<template>
    <v-card class="ma-2 time-card">
        <v-card-text>
            <div class="sickleave-title">Sick Leave</div>
            <v-flex class="mb-2" xs12>Days left: {{LeftSickLeaveDays}}</v-flex>
            <v-divider class="mb-3"></v-divider>
            <v-form v-model="formValid" ref="form" lazy-validation novalidate>
                <v-layout align-center>
                    <v-flex xs1>
                        <div class="mx-3">
                            <v-btn flat color="black" disabled class="add-sickleave-btn">
                                {{getSickLeaveDuration(this.sickLeaveStartDate, this.sickLeaveEndDate)}}
                            </v-btn>
                        </div>
                    </v-flex>
                    <v-flex xs3>
                        <div class="mx-3">
                            <v-menu :disabled="LeftSickLeaveDays === 0 || !isEditEnabled" ref="menuHiring" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field :rules="dateRules" required slot="activator" label="Start date" v-model="sickLeaveStartDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="sickLeaveStartDate" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs3>
                        <div class="mx-3">
                            <v-menu :disabled="LeftSickLeaveDays === 0 || !isEditEnabled" ref="menuHiring" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field :rules="dateRules" required slot="activator" label="End date" v-model="sickLeaveEndDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="sickLeaveEndDate" :allowed-dates="sickLeaveAllowedDays" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs4>
                        <div class="mx-3">
                            <v-text-field :disabled="LeftSickLeaveDays === 0 || !isEditEnabled" v-model="sickLeaveComment" label="Comment"></v-text-field>
                        </div>
                    </v-flex>
                    <v-flex class="text-xs-center" xs1>
                        <v-btn :disabled="LeftSickLeaveDays === 0 || !isEditEnabled" flat color="black" @click.stop.prevent="addNewSickLeave()" slot="activator" class="add-sickleave-btn">
                            <v-icon color="indigo">mdi-plus</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-form>
            <template v-for="sickLeave in sickLeaves">
                <v-divider :key="`divider-${sickLeave.id ? `id${sickLeave.id}` : `obsId${sickLeave.observationId}`}`" class="mb-3"></v-divider>
                <v-layout :key="`layout-${sickLeave.id ? `id${sickLeave.id}` : `obsId${sickLeave.observationId}`}`" align-center>
                    <v-flex xs1>
                        <div class="mx-3">
                            <v-btn flat color="black" disabled class="add-sickleave-btn">
                                {{getSickLeaveDuration(sickLeave.startDate, sickLeave.endDate)}}
                            </v-btn>
                        </div>
                    </v-flex>
                    <v-flex xs3>
                        <div class="mx-3">
                            <v-menu :disabled="!isEditEnabled" ref="menuHiring" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field :rules="dateRules" required slot="activator" label="Start date" v-model="sickLeave.startDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="sickLeave.startDate" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs3>
                        <div class="mx-3">
                            <v-menu :disabled="!isEditEnabled" ref="menuHiring" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                    <v-text-field :rules="dateRules" required slot="activator" label="End date" v-model="sickLeave.endDate" prepend-icon="event" readonly></v-text-field>
                                    <v-date-picker v-model="sickLeave.endDate" no-title scrollable actions>
                                    </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs4>
                        <div class="mx-3">
                            <v-text-field v-model="sickLeave.comment" label="Comment"></v-text-field>
                        </div>
                    </v-flex>
                    <v-flex class="text-xs-center" xs1>
                        <v-btn flat :disabled="!isEditEnabled" color="black" @click.stop.prevent="removeExistSickLeave(sickLeave)" slot="activator" class="add-sickleave-btn">
                            <v-icon color="indigo">mdi-delete</v-icon>
                        </v-btn>
                        <v-btn :disabled="!isEditEnabled" flat color="black" @click="editExistSickLeave(sickLeave)" slot="activator" class="add-sickleave-btn">
                            <v-icon color="indigo">mdi-content-save</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </template>
        </v-card-text>
    </v-card>
</template>

<script>
    import moment from 'moment';
    import {
        mapGetters, mapActions
    } from 'vuex';

    export default {
        name: 'EmployeeSickLeave',
        data() {
            return {
                sickLeaveStartDate: null,
                sickLeaveEndDate: null,
                sickLeaveComment: null,
                leftSickLeaveDays: 0,
                formValid: false,
                observationId: 0,
                dateRules: [ v => !!v || 'Choose date' ]
            };
        },
        created() {
        },
        computed: {
            ...mapGetters({
                employee: 'getEmployee',
                sickLeaves: 'getAllSickLeaves',
                positions: 'getPositions'
            }),
            LeftSickLeaveDays: {
                get() {
                    const firstContractStart = moment.min(this.positions.map((position) => moment(position.contractStart)));

                    // Sickleaves were added in september 2018
                    const sickLeavesWereActive = moment('01-09-2018', 'DD-MM-YYYY') < moment(firstContractStart);
                    const startDate = sickLeavesWereActive ? moment(firstContractStart) : moment('01-09-2018', 'DD-MM-YYYY');
        
                    const workedMonths = ~~(moment(new Date()).diff(startDate, 'months', true));

                    // all employees that are working in company before september 2018 gains 2 sickleaves
                    const sickLeavesAmount = (sickLeavesWereActive ? 0 : 2) + ~~(workedMonths / 3);
                    const sickLeavesTaken = this.sickLeaves
                                .map((sickLeave) => moment.duration(moment(sickLeave.endDate)
                                .diff(sickLeave.startDate)).asDays() + 1).reduce((total, amount) => total + amount, 0)
                    
                    const sickLeavesLeft = sickLeavesAmount - sickLeavesTaken;
                    
                    // employee cannot have more than 5 sickleaves at one time
                    return sickLeavesLeft > 5 ? 5 : sickLeavesLeft;
                },
                set(value) {
                    this.leftSickLeaveDays = value;
                }
            },
            isEditEnabled() {
                return !this.employee.archived;
            }
        },
        methods: {
            ...mapActions([
                'addSickLeave',
                'editSickLeave',
                'removeSickLeave'
            ]),
            addNewSickLeave() {
                if (this.$refs.form.validate()) {
                    const sickLeave = {
                        observationId: this.observationId++,
                        startDate: this.sickLeaveStartDate,
                        endDate: this.sickLeaveEndDate,
                        comment: this.sickLeaveComment,
                        user: {
                            userId: this.employee.userId
                        }
                    };

                    const sickLeaveDuration = this.getSickLeaveDuration(this.sickLeaveStartDate, this.sickLeaveEndDate);
                    this.LeftSickLeaveDays -= sickLeaveDuration;
                    this.addSickLeave(sickLeave).then(() => {
                        this.$refs.form.reset();
                    });
                }
            },
            removeExistSickLeave(sickLeave) {
                this.removeSickLeave(sickLeave).then(() => {
                    const sickLeaveDuration = moment.duration(moment(sickLeave.endDate)
                        .diff(moment(sickLeave.startDate))).asDays() + 1;
                    this.LeftSickLeaveDays += sickLeaveDuration;
                });
            },
            editExistSickLeave(sickLeave) {
                this.editSickLeave(sickLeave);
            },
            sickLeaveAllowedDays(date) {
                return moment(date).isSameOrAfter(moment(this.sickLeaveStartDate)) &&
                    moment(date).isBefore(moment(this.sickLeaveStartDate).add(this.LeftSickLeaveDays, 'days'));
            },
            formatDate(date) {
                return moment(date).format('YYYY-MM-DD');
            },
            getSickLeaveDuration(startDate, endDate) {
                return !!startDate && !!endDate
                    ? moment.duration(moment(endDate)
                        .diff(moment(startDate))).asDays() + 1
                    : 0;
            }
        }
    };
</script>

<style scoped>
.sickleave-title {
  font-size: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.add-sickleave-btn >>> .btn__content {
  padding: 0;
}

.add-sickleave-btn {
  min-width: 32px;
  width: 32px;
  min-height: 32px;
  height: 32px;
  margin: 6px 0px 14px 6px;
  background-color: #ced2e6 !important;
  font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/reusable/EmployeeSickLeave.vue